import { useState } from "react";
import { handleUploadFileWithResult } from "../utils/uploadFileS3";

const UPLOAD_ASSET_URL = (process.env.NODE_ENV === "production" || process.env.VERCEL_ENV === "production")
  ? "https://simply.api.prod.proxyedge.io/general/api/assets/upload"
  : "https://bf6q09zw9f.execute-api.ap-southeast-1.amazonaws.com/test/api/assets/upload";


export default function useUploadAsset() {
  const [resultFileUrl, setResultFileUrl] = useState<string>();
  const [uploadFileError, setUploadFileError] = useState<boolean>();

  async function uploadFile(key: string, file: File) {
    setResultFileUrl(undefined);
    setUploadFileError(undefined);

    const url = UPLOAD_ASSET_URL + "?key=" + key;
    console.log("uploading file", url);
    const result = await handleUploadFileWithResult(url, file);

    if (result === null) {
      setUploadFileError(true);
      return;
    }

    setResultFileUrl(result.fileUrl);
    setUploadFileError(false);
    return { resultFileUrl: result.fileUrl }
  }

  return { uploadFile, resultFileUrl, uploadFileError };
}